<template>
  <div class="w-100">
		<span id="top_section"></span>
		<div v-if="is_load" class="w-100 py-4 text-center">
      <loader />
    </div>
    <template v-else>
    	<div class="p-4" v-if="error != ''">
      	<ErrorMessage :message="error" />
    	</div>
    	<template v-else>
        <div :class="payment_in_page ? '' : 'px-4 pt-5 pb-4'">
          <template v-if="!payment_in_page">
            <div class="w-100 d-flex border-form box-shadow-light-aff p-3 radius-6 bg-white mb-5">
              <div class="img-merchant mr-3">
                <img :src="getMerchant.image_url">
              </div>
              <div class="w-100 pl-3">
                <p class="body-1-4 mb-0">{{ getMerchant.name }}</p>
                <p class="body-3-3 mb-0" v-if="$isNotEmpty(getMerchant.phone)">{{ getMerchant.phone }}</p>
                <p class="body-3 mb-0">{{ getMerchant.address }}</p>
              </div>
            </div>
            
            <div class="w-100 border-form box-shadow-light-aff p-3 radius-6 bg-white mb-5">
              <div class="d-flex align-items-center border-b-form pb-3">
                <div class="room-icon">
                  <svg width="27" height="18" viewBox="0 0 27 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M0.90586 17.9786H1.54529C2.08881 17.9786 2.45115 17.627 2.45115 17.0728V15.4956C2.56838 15.5275 2.92007 15.5489 3.17584 15.5489H23.8294C24.0852 15.5489 24.4369 15.5275 24.5541 15.4956V17.0728C24.5541 17.627 24.9164 17.9786 25.46 17.9786H26.0994C26.6536 17.9786 27.0053 17.627 27.0053 17.0728V9.77264C27.0053 7.73711 25.897 6.63942 23.8614 6.63942H3.14387C1.10835 6.63942 0 7.73711 0 9.77264V17.0728C0 17.627 0.351687 17.9786 0.90586 17.9786ZM2.13144 13.9929C1.90764 13.9929 1.76909 13.833 1.76909 13.5773V9.52755C1.76909 8.71757 2.30195 8.19537 3.13321 8.19537H23.8827C24.7034 8.19537 25.2362 8.71757 25.2362 9.52755V13.5773C25.2362 13.833 25.0977 13.9929 24.8739 13.9929H2.13144ZM2.77087 6.86323H5.57371V4.66784C5.57371 3.67673 6.12788 3.13321 7.14031 3.13321H10.8809C11.8827 3.13321 12.4369 3.67673 12.4369 4.66784V6.86323H14.5683V4.66784C14.5683 3.67673 15.1225 3.13321 16.1243 3.13321H19.865C20.8774 3.13321 21.4316 3.67673 21.4316 4.66784V6.86323H24.2344V2.98401C24.2344 1.01243 23.1794 0 21.2611 0H5.74422C3.83658 0 2.77087 1.01243 2.77087 2.98401V6.86323Z"
                      fill="white" />
                  </svg>
                </div>
                <div class="w-70 px-3">
                  <p class="body-1-4 mb-0">{{ data.room_type.name }}</p>
                  <p class="body-3 mb-0">{{ data.room.name }}</p>
                </div>
                <div class="w-30 pr-3 text-right">
                  <p class="body-1-4 mb-0 text-green">#{{ folio_number }}</p>
                  <p class="body-3 mb-0">Folio Number</p>
                </div>
              </div>
              <div class="w-100 d-flex align-items-center">
                <div class="w-40 border-r-form pt-3">
                  <p class="mb-0 body-2-4">{{ guest_profile.name }}</p>
                  <p class="mb-0 body-3">Guest Name</p>
                </div>
                <div class="w-30 text-center pt-3">
                  <p class="mb-0 body-2-4 text-green">{{ $formatDate(data.arrival_date,'YYYY-MM-DD') }}</p>
                  <p class="mb-0 body-3">Checkin</p>
                </div>
                <div class="w-30 text-center pt-3">
                  <p class="mb-0 body-2-4 text-danger">{{ $formatDate(data.departure_date,'YYYY-MM-DD') }}</p>
                  <p class="mb-0 body-3">Checkout</p>
                </div>
              </div>
            </div>
  
            <!-- HISTORY -->
            <div class="w-100 border-form box-shadow-light-aff p-3 radius-6 bg-white mb-5">
              <div class="d-flex w-100 border-b-form text-center pt-2">
                <div 
                  class="d-flex align-items-center justify-content-center pb-3 w-50 cursor-pointer" 
                  :class="tab_history == 'bill' ? 'border-bottom-green-4' : 'border-b-white-4'"
                  @click="toggleTabHistory('bill')">
                  <div class="mr-2 lh-1">
                    <svg width="24" height="18" viewBox="0 0 24 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <g clip-path="url(#clip0_796_32)">
                        <path
                          d="M3.07008 18H19.9848C22.0381 18 23.0549 16.993 23.0549 14.9788V3.03096C23.0549 1.01684 22.0381 0 19.9848 0H3.07008C1.02662 0 0 1.01684 0 3.03096V14.9788C0 16.993 1.02662 18 3.07008 18ZM3.08962 16.4259C2.1119 16.4259 1.57415 15.9077 1.57415 14.8909V3.11896C1.57415 2.10212 2.1119 1.57415 3.08962 1.57415H19.9653C20.9332 1.57415 21.4807 2.10212 21.4807 3.11896V14.8909C21.4807 15.9077 20.9332 16.4259 19.9653 16.4259H3.08962Z"
                          :class="tab_history == 'bill' ? 'fill-primary' : 'fill-light'" />
                        <path
                          d="M4.63445 5.34819C5.14287 5.34819 5.54374 4.93754 5.54374 4.4389C5.54374 3.93048 5.14287 3.52961 4.63445 3.52961C4.14559 3.52961 3.72516 3.94026 3.72516 4.4389C3.72516 4.92776 4.14559 5.34819 4.63445 5.34819ZM4.63445 8.34004C5.14287 8.34004 5.54374 7.9294 5.54374 7.43075C5.54374 6.92234 5.14287 6.52147 4.63445 6.52147C4.14559 6.52147 3.72516 6.93211 3.72516 7.43075C3.72516 7.91962 4.14559 8.34004 4.63445 8.34004ZM4.63445 11.3221C5.14287 11.3221 5.54374 10.9212 5.54374 10.4129C5.54374 9.91418 5.14287 9.51328 4.63445 9.51328C4.13581 9.51328 3.72516 9.92394 3.72516 10.4129C3.72516 10.9212 4.13581 11.3221 4.63445 11.3221ZM4.63445 14.4606C5.14287 14.4606 5.54374 14.05 5.54374 13.5514C5.54374 13.0429 5.14287 12.6323 4.63445 12.6323C4.14559 12.6323 3.72516 13.0527 3.72516 13.5514C3.72516 14.0402 4.14559 14.4606 4.63445 14.4606ZM7.5872 5.03532H18.7724C19.1244 5.03532 19.3884 4.77133 19.3884 4.4389C19.3884 4.0967 19.1147 3.82293 18.7724 3.82293H7.5872C7.24499 3.82293 6.97123 4.0967 6.97123 4.4389C6.97123 4.77133 7.23522 5.03532 7.5872 5.03532ZM7.5872 8.03694H13.786C14.1185 8.03694 14.3922 7.76318 14.3922 7.43075C14.3922 7.09832 14.1185 6.81478 13.786 6.81478H7.5872C7.24499 6.81478 6.97123 7.09832 6.97123 7.43075C6.97123 7.76318 7.24499 8.03694 7.5872 8.03694ZM7.5872 11.0288H18.7724C19.1244 11.0288 19.3884 10.7648 19.3884 10.4129C19.3884 10.0804 19.1244 9.81639 18.7724 9.81639H7.5872C7.23522 9.81639 6.97123 10.0804 6.97123 10.4129C6.97123 10.7648 7.23522 11.0288 7.5872 11.0288ZM7.5872 14.1576H13.786C14.1185 14.1576 14.3922 13.8838 14.3922 13.5514C14.3922 13.2091 14.1282 12.9451 13.786 12.9451H7.5872C7.23522 12.9451 6.97123 13.2091 6.97123 13.5514C6.97123 13.8838 7.24499 14.1576 7.5872 14.1576Z"
                          :class="tab_history == 'bill' ? 'fill-primary' : 'fill-light'" />
                      </g>
                      <defs>
                        <clipPath id="clip0_796_32">
                          <rect width="23.0549" height="18" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>
                  </div>
                  <p class="mb-0" :class="tab_history == 'bill' ? 'body-2-4 text-green' : 'body-2'">Bill</p>
                </div>
                <div 
                  class="d-flex align-items-center justify-content-center pb-3 w-50 cursor-pointer" 
                  :class="tab_history == 'payment' ? 'border-bottom-green-4' : 'border-b-white-4'"
                  @click="toggleTabHistory('payment')">
                  <div class="mr-2 lh-1">
                    <svg width="25" height="18" viewBox="0 0 25 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <g clip-path="url(#clip0_797_37)">
                        <path
                          d="M4.72909 14.3137H7.30955C7.93097 14.3137 8.34174 13.8923 8.34174 13.3026V11.354C8.34174 10.7536 7.93097 10.3429 7.30955 10.3429H4.72909C4.10767 10.3429 3.69691 10.7536 3.69691 11.354V13.3026C3.69691 13.8923 4.10767 14.3137 4.72909 14.3137ZM0.853133 6.59335H23.9088V4.20247H0.853133V6.59335ZM3.30721 18H21.4442C23.656 18 24.7514 16.9152 24.7514 14.7455V3.27561C24.7514 1.10591 23.656 0.0105324 21.4442 0.0105324H3.30721C1.10591 0.0105324 0 1.10591 0 3.27561V14.7455C0 16.9152 1.10591 18 3.30721 18ZM3.32826 16.3043C2.27502 16.3043 1.69573 15.7461 1.69573 14.6507V3.3704C1.69573 2.27502 2.27502 1.70627 3.32826 1.70627H21.4231C22.4553 1.70627 23.0556 2.27502 23.0556 3.3704V14.6507C23.0556 15.7461 22.4553 16.3043 21.4231 16.3043H3.32826Z"
                          :class="tab_history == 'payment' ? 'fill-primary' : 'fill-light'" />
                      </g>
                      <defs>
                        <clipPath id="clip0_797_37">
                          <rect width="24.7514" height="18" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>
                  </div>
                  <p class="mb-0" :class="tab_history == 'payment' ? 'body-2-4 text-green' : 'body-2'">Payment</p>
                </div>
              </div>
              
              <!-- BILL -->
              <template v-if="tab_history == 'bill'">
                <div 
                  class="row no-gutters justify-content-start py-3"
                  :class="{'border-b-form-dashed-2' : bill_index+1 != guest_bill.list.length, 'border-b-form': bill_index+1 == guest_bill.list.length}"  
                  v-for="(bill_item,bill_index) in guest_bill.list" 
                  :key="bill_index" >
                  <div class="col-7">
                    <p class="mb-0 body-2-1 font-bold">{{bill_item.description}}</p>
                    <p class="mb-0 body-3-3-1">{{bill_item.remark}}</p>
                  </div>
                  <div class="col-5 text-right">
                    <p class="mb-0 text-14 font-lato">{{$formatCurrency(bill_item.amount)}}</p>
                    <p class="mb-0 body-3-3-1">{{$formatDate(bill_item.dates)}}</p>
                  </div>
                </div>
              </template>
  
              <!-- PAYMENT -->
              <template v-else>
                <div 
                  class="row no-gutters justify-content-start py-3"
                  :class="{'border-b-form-dashed-2' : payment_index+1 != guest_bill.payment.length, 'border-b-form': payment_index+1 == guest_bill.payment.length}" 
                  v-for="(payment_item,payment_index) in guest_bill.payment">
                    <div class="col-7">
                      <p class="mb-0 body-2-1">{{payment_item.description}}</p>
                      <p class="mb-0 body-3-3-1">{{$formatDate(payment_item.dates)}}</p>
                    </div>
                    <div class="col-5 text-right">
                      <p class="mb-0 text-14 font-lato">{{$formatCurrency(payment_item.amount)}}</p>
                    </div>
                </div>
                <div class="w-100 text-center py-3" v-if="guest_bill.payment.length == 0">
                  <p class="mb-0 body-2"><i>You haven't made any payments at all</i></p>
                </div>
              </template>
  
              <div class="row no-gutters pt-3 pb-1">
                <div class="col-7">
                  <p class="mb-0 body-2-1">{{$t('hotel.concierge.total')}}</p>
                </div>
                <div class="col-5 text-right">
                  <p class="mb-0 text-16 font-lato">{{$formatCurrency(guest_bill.total_bill)}}</p>
                </div>
              </div>
              <div class="row no-gutters pt-2">
                <div class="col-7">
                  <p class="mb-0 body-2-1 text-success">{{$t('hotel.concierge.paid')}}</p>
                </div>
                <div class="col-5 text-right">
                  <p class="mb-0 text-16 font-lato text-success">{{$formatCurrency(guest_bill.total_payment)}}</p>
                </div>
              </div>
              <div class="row no-gutters pt-2">
                <div class="col-7">
                  <p class="mb-0 body-2-1 text-danger">{{$t('hotel.concierge.balance')}}</p>
                </div>
                <div class="col-5 text-right">
                  <p class="mb-0 text-16 font-lato text-danger">{{$formatCurrency(guest_bill.balance)}}</p>
                </div>
              </div>
            </div>
  
            <template v-if="guest_bill.balance > 0">
              <!-- PAYMENT METHODS  -->
              <div class="w-100 border-form box-shadow-light-aff p-3 radius-6 bg-white mb-5">
                <div class="w-100 mb-4">
                  <p class="mb-0 body-1-4">Select payment method</p>
                  <p class="mb-0 body-3-3-1">Choose your preferred way to pay securely.</p>
                </div>
                <div class="w-100">
                  <PaymentMethod ref="payment_method" module="hotel-reservation" @selectPayment="selectPayment"></PaymentMethod>
                </div>
                <div class="mt-4 pt-4 border-t-form-2-dashed" v-if="show_form_contact">
                  <div class="mb-3" id="contact_form">
                    <p class="mb-0 body-1-4">Contact Detail</p>
                    <p class="mb-0 body-3-3-1">Some payment methods require your contact information</p>
                  </div>
                  <div class="w-100">
                    <!-- EMAIL -->
                    <div class="w-100 mb-4" v-if="contact_form.show.email">
                      <label class="body-3 mb-1 d-block">{{$t('hotel.visitor-detail.email')}} <span class="font-weight-bold text-danger">*</span></label>
                      <div class="position-relative">
                        <input 
                        type="text" 
                        class="p-2-5 body-2-1 w-100 border-form radius-6" 
                        :class="{'border-danger': contact_form.error.email != ''}"
                        placeholder="email@example.com" 
                        v-model="contact_form.email" >
                        <div class="position-absolute" style="top:12px;right:16px;">
                          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g id="local_post_office_24px">
                            <path id="icon/maps/local_post_office_24px" fill-rule="evenodd" clip-rule="evenodd" d="M22 6C22 4.90002 21.1 4 20 4H4C2.90002 4 2 4.90002 2 6V18C2 19.1 2.90002 20 4 20H20C21.1 20 22 19.1 22 18V6ZM20 6L12 11L4 6H20ZM12 13L4 8V18H20V8L12 13Z" fill="black" fill-opacity="0.54"/>
                            </g>
                          </svg>
                        </div>
                      </div>
                      <p class="w-100 mb-0 mt-1 body-3 text-danger" v-if="contact_form.error.email != ''">{{ contact_form.error.email }}</p>
                    </div>
                
                    <!-- PHONE -->
                    <div class="w-100" v-if="contact_form.show.phone_number">
                      <label class="body-3 mb-1 d-block">{{$t('hotel.visitor-detail.phone-number')}} <span class="font-weight-bold text-danger">*</span></label>
                      <div class="position-relative w-100 border-form radius-6" :class="{'border-danger': contact_form.error.phone_number != ''}">
                        <div class="row no-gutters">
                          <div class="col-5 align-self-center">
                            <div class="pr-4 border-r-form" :key="form_key">
                              <v-select
                                class="border-none"
                                :clearable="false"
                                :options="data_option.country"
                                @input="refreshFrom()" 
                                label="label" 
                                v-model="contact_form.dial_code">
                                  <template #search="{ attributes, events }">
                                    <input
                                      :placeholder="contact_form.dial_code.code ? '' : '+00'"
                                      class="vs__search no-focus-border"
                                      v-bind="attributes"
                                      v-on="events"
                                    />
                                  </template>
                                
                                  <template #selected-option="{ dial_code }">
                                    <p class="mb-0 body-2-1">{{ dial_code }}</p>
                                  </template>
                                  <template v-slot:option="option">
                                    <div class="d-inline-block align-middle mr-2">
                                      <country-flag :country='option.code' size='small'/>
                                    </div>
                                    <p class="mb-0 d-inline-block align-middle body-2-1">{{`${option.code} (${option.dial_code})`}}</p>
                                </template>
                              </v-select>
                            </div>
                          </div>
                          <div class="col-7 align-self-center">
                            <input type="number" class="w-100 border-none no-focus-border body-2-1 pl-3" placeholder="000 000 000" v-model="contact_form.phone_number" >
                          </div>
                        </div>
                        <div class="position-absolute" style="top:12px;right:16px;">
                          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g id="phone_24px">
                              <path id="icon/communication/phone_24px" fill-rule="evenodd" clip-rule="evenodd" d="M4 3H7.5C8.04999 3 8.5 3.45001 8.5 4C8.5 5.25 8.70001 6.45001 9.07001 7.57001C9.17999 7.92001 9.09998 8.31 8.82001 8.59L6.62 10.79C8.06 13.62 10.38 15.93 13.21 17.38L15.41 15.18C15.61 14.99 15.86 14.89 16.12 14.89C16.22 14.89 16.33 14.9 16.43 14.94C17.55 15.31 18.76 15.51 20 15.51C20.55 15.51 21 15.96 21 16.51V20C21 20.55 20.55 21 20 21C10.61 21 3 13.39 3 4C3 3.45001 3.45001 3 4 3ZM6.54004 5C6.60004 5.89001 6.75 6.76001 6.99005 7.59L5.79004 8.79001C5.38 7.59 5.12006 6.32001 5.03003 5H6.54004ZM16.4 17.02C17.25 17.26 18.12 17.41 19 17.47V18.96C17.68 18.87 16.41 18.61 15.2 18.21L16.4 17.02Z" fill="black" fill-opacity="0.54"/>
                            </g>
                          </svg>
                        </div>
                      </div>
                      <p class="w-100 mb-0 mt-1 body-3 text-danger" v-if="contact_form.error.phone_number != ''">{{ contact_form.error.phone_number }}</p>
                    </div>
                  </div>
                </div>
              </div>
    
              <div class="w-100">
                <div class="py-3" v-if="error_push != ''">
                  <ErrorMessage :message="error_push" />
                </div>
                <state-button variant="primary" size="xl" block :click="submitForm">Pay Now</state-button>
              </div>
            </template>
          </template>
          <div v-else class="w-100 p-3 radius-6 bg-white">
            <XenditInputCC
              :tx_payment="tx_payment"
              module_page="CONCIERGE_RESERVATION">
            </XenditInputCC>
          </div>
        </div>
      </template>
    </template>
  </div>
</template>

<script>
  import {get,post} from '@/services/index.js'
  import { mapGetters } from 'vuex'
  import PaymentMethod from '@/components/general/payment/PaymentMethod'
  import country from "@/data/country"
	import { parsePhoneNumber, parsePhoneNumberFromString ,ParseError  } from 'libphonenumber-js'
  import Inputmask from "inputmask";
	import 'inputmask/dist/inputmask.min.js';
	import 'inputmask/dist/bindings/inputmask.binding.js';
  import CountryFlag from 'vue-country-flag'
  import { validationMixin } from "vuelidate";
  const { required, email } = require("vuelidate/lib/validators");
  import XenditInputCC from '@/components/hotel/be/XenditInputCC';

  export default {
    components:{
      PaymentMethod,
      CountryFlag,
      XenditInputCC
    },
    data() {
      return {
        is_load: true,
        error: '',
        data: {},
        guest_bill: {},
        tab_history: 'bill',
        payment_method: {},
        data_option:{
          country: country
        },
        form_key: 0,
        contact_form:{
          show: {
            email: false,
            phone_number: false
          },
          email: '',
          dial_code: {},
		      phone_number: '',
          error:{
            email: '',
            phone_number: '',
          }
        },
        error_push: '',
        payment_in_page: false,
        tx_payment: {}
      }
    },
    mixins: [validationMixin],
    validations: {
      contact_form:{
        email: {
          required,
          email
        },
        phone_number:{
          required
        }
      }
    },
    computed:{
      ...mapGetters(['getMerchant']),
      folio_number(){
        let folio = this.$route.query.folio
        if(folio) return folio
        return ''
      },
      rsv_id(){
        return this.$route.params.invoice_id
      },
      show_form_contact(){
        return this.contact_form.show.email || this.contact_form.show.phone_number
      },
      guest_profile(){
        let data = this.$isNotEmpty(this.data.guest_profile) ? this.data.guest_profile : this.data.folio.booked_by
        return data 
      },
      payment_surcharge(){
				let total = 0

				if(this.payment_method.id){
					if(this.payment_method.surcharge_type == 'PERCENT'){
						total = (this.guest_bill.balance/100)*this.payment_method.surcharge_value
					}else{
						total = this.payment_method.surcharge_value
					}
				}

				return total
			},
    },
    mounted(){
      this.loadFirstData()
    },
    methods:{
      loadFirstData(){
        this.is_load = true
        this.error = ''
        Promise.all([
          this.loadDetailRsv(),
          this.loadGuestBill()
        ])
        .catch(err=>this.error = err)
        .finally(()=>this.is_load = false)
      },
      loadDetailRsv(){
        return new Promise((success,fail)=>{
          this.data = {}
          let url = `reservation/${this.rsv_id}/${this.folio_number}`
          get("CONCIERGE",url,{
            merchant_id: this.getMerchant.id
          }).then(response=>{
            let res = response.data
            if(res.success){
              this.data = res.data
              if(!this.$isNotEmpty(res.data.room_type)){
                this.data.room_type= {}
                this.data.room_type.name = 'Unallocated Room Type'
              }
              if(!this.$isNotEmpty(res.data.room)){
                this.data.room = {}
                this.data.room.name = 'Unallocated Room'
              }
              this.setupContactForm()
              success()
            }else fail(res.message)
          })
        })
      },
      loadGuestBill(){
        return new Promise((success,fail)=>{
          this.guest_bill = {
            list: [],
            payment: [],
            total_bill: 0,
            total_payment: 0,
            balance: 0
          }
          let url = `reservation/${this.rsv_id}/${this.folio_number}/guest-bill`
          get("CONCIERGE",url,{
            merchant_id: this.getMerchant.id
          }).then(response=>{
            let res = response.data
            if(res.success){
              res.data.forEach((item,index)=>{
                if(item.type == 'PAYMENT'){
                  this.guest_bill.payment.push(item)
                  this.guest_bill.total_payment += item.amount
                }else{
                  this.guest_bill.list.push(item)
                  this.guest_bill.total_bill += item.amount
                }
              })
              this.guest_bill.balance = this.guest_bill.total_bill-this.guest_bill.total_payment
              success()
            }else fail(res.message)
          })
        })
      },
      toggleTabHistory(tab){
        this.tab_history = tab
      },
      selectPayment(pm){
        this.payment_method = pm
        if(this.show_form_contact){
          setTimeout(() => {
            this.$smoothScroll('contact_form')
          }, 300);
        }
      },
      setupPhoneNumber(){
        this.data_option.country = this.data_option.country.map(x=>{
          x.label = `${x.code}/${x.dial_code}`
          return x
        })
        $(document).ready(function(){
          Inputmask().mask(document.querySelectorAll("input"));
        });
      },
      setupContactForm(){
        this.contact_form.email = this.guest_profile.email
        this.contact_form.show.email = this.$v.contact_form.email.$invalid
        this.contact_form.phone_number = this.guest_profile.phone
        if(this.$isNotEmpty(this.guest_profile.phone)){
          this.checkPhoneNumber()
        }else{
          this.setupPhoneNumber()
          this.contact_form.show.phone_number = true
        } 
      },
      checkPhoneNumber(){
        let phone_number = this.contact_form.phone_number
        if(!(phone_number == '#' || phone_number == '' || phone_number == undefined || phone_number == null)){
          try{
            const phone_parsed = parsePhoneNumberFromString(phone_number)
            if (phone_parsed) {
              this.contact_form.dial_code = this.data_option.country.find(x => x.dial_code.slice(1) == phone_parsed.countryCallingCode)
              this.contact_form.phone_number = phone_parsed.nationalNumber
            }else{
              for(let i = 0; i < this.data_option.country.length; i++){
                let el = this.data_option.country[i]
                let check_country = parsePhoneNumber(phone_number,el.code)
                if(check_country.isValid()){
                  this.contact_form.dial_code = this.data_option.country.find(x => x.code == check_country.country)
                  this.contact_form.phone_number = check_country.nationalNumber
                  break;
                }
                if(i+1 == this.data_option.country.length && !check_country.isValid()){
                  console.log("Invalid phone number")
                  this.contact_form.phone_number = ''
                  this.contact_form.show.phone_number = true
                  this.setupPhoneNumber()
                }
              }
            }
          }catch(err){
            console.log("PHONE NUMBER ERROR :", err.message)
            this.contact_form.phone_number = ''
            this.contact_form.show.phone_number = true
            this.setupPhoneNumber()
          }
        }
      },
      refreshFrom(){
        this.form_key++
      },
      validateForm(){
        return new Promise((success,fail)=>{
          this.error_push = ''
          if(!this.payment_method.id){
            this.error_push = 'Please select payment method'
            fail()
          }else{
            this.contact_form.email = this.contact_form.email.trim()
            this.contact_form.phone_number = this.contact_form.phone_number.trim()
            this.contact_form.error = {
              email: '',
              phone_number: ''
            }
  
            let form_val = this.$v.contact_form
  
            if(this.contact_form.show.email){ 
              this.contact_form.error.email = form_val.email.$invalid ? this.$t('hotel.visitor-detail.email-warning') : '' 
            }
  
            let full_pn = `${this.contact_form.dial_code.code}${this.contact_form.phone_number}`
            if(!this.contact_form.dial_code.code) this.contact_form.error.phone_number = this.$t('hotel.visitor-detail.country-code-warning')
            else if(form_val.phone_number.$invalid) this.contact_form.error.phone_number = this.$t('hotel.visitor-detail.phone-number-warning')
            else if(full_pn.length < 10) this.contact_form.error.phone_number = this.$t('hotel.visitor-detail.phone-number-invalid')
            
            let email_phone_valid = this.contact_form.error.email == '' && this.contact_form.error.phone_number == ''
            if(email_phone_valid) success()
            else{
              setTimeout(() => {
                this.$smoothScroll('contact_form')
              }, 300);  
              fail()
            }
          }
        })
      },
      submitForm(){
        return new Promise((success,fail)=>{
          this.validateForm().then(()=>{
            this.error_push = ''
            let params = {
              amount: this.guest_bill.balance,
              merchant_id: this.getMerchant.id,
              payment_details: {
                bank_name: this.payment_method.bank_name,
                id: this.payment_method.id,
                payment_method: this.payment_method.payment_method
              },
              reservation_id: this.data.id
            }
            
            if(this.show_form_contact){
              params.customer_detail = {}
              if(this.contact_form.show.email){
                params.customer_detail.email = this.contact_form.email
              }
              if(this.contact_form.show.phone_number){
                params.customer_detail.phone_number = `${this.contact_form.dial_code.dial_code}${this.contact_form.phone_number}`
              }
            }
            
            post("CONCIERGE","tx-guest-bill-payment",params).then(response => {
              let res = response.data
              if(res.success){
                let res_payment = res
                res_payment.payment.reservation = this.data
                
                this.tx_payment = res_payment.payment
                if(this.payment_method.bank_name == 'XENDIT' && this.payment_method.payment_method == 'CREDIT_CARD'){
                  this.payment_in_page = true
                }else{
                  this.$proceedPayment('CONCIERGE_RESERVATION',{},res_payment,this.payment_method)
                }
                success()
              }else{
                this.error_push = res.message
                fail()
              }
            })
          })
          .catch(()=>fail())
        })
      }
    }
  }
</script>
<style>
.room-icon{
  width: 70px;
  height: 50px;
  background-color: var(--merchant-primary-color);
  border-radius: 6px;
  display: grid;
  place-items: center;
  flex-shrink: 0;
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
}
input[type=number]{
    -moz-appearance: textfield;
}
.img-merchant{
  width: 100px;
  height: 80px;
  border-radius: 6px;
  overflow: hidden;
  flex-shrink: 0;
}
.img-merchant img{
  object-fit: contain;
  width: 100%;
  height: 100%;
}
</style>


// WEBPACK FOOTER //
// src/pages/hotel/PaymentBill.vue